import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function AddPlugMeterGroup(props) {
  const {
    show,
    onHide,
    showToast,
    setMeterGroups,
    setActiveMeterGroupId,
    organizationId,
  } = props;

  const [groupName, setGroupName] = useState('');

  const [disabled, setDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (groupName) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [groupName]);

  const addGroup = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.post(
      `/plug_meter_groups`,
      {
        name: groupName,
        organization_id: organizationId,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setMeterGroups((prev) => [...prev, res.data]);
        setActiveMeterGroupId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setGroupName('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Add Meter Group</Modal.Header>
      <Form onSubmit={addGroup}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Group Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setGroupName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
